/**
 * Purpose:
 *   Tailwind CSS class constants for Toast component.
 */

export const toastStyles = {
  base: `
    min-w-[360px] max-w-[420px] pointer-events-auto relative overflow-hidden
    rounded-xl border px-4 py-2 text-neutral-500 shadow
    flex items-center gap-3
  `,

  variant: {
    error: 'border-red-600 bg-red-0',
    warning: 'border-yellow-500 bg-yellow-0',
    success: 'border-green-600 bg-green-0',
  },

  dot: {
    base: 'h-2.5 w-2.5 rounded-full',
    error: 'bg-red-600',
    warning: 'bg-yellow-500',
    success: 'bg-green-600',
  },

  message: `
    flex-1 min-w-0
  `,

  messageText: `
    b3 break-words whitespace-pre-line
  `,

  closeButton: `
    ml-2 inline-flex h-8 w-8 items-center justify-center
    rounded-full
    focus:outline-none focus:ring-2 focus:ring-neutral-200 focus:ring-offset-2
    text-neutral-400 hover:text-neutral-500
  `,

  progressBar: `
    absolute left-0 right-0 bottom-0 h-0.5 toast-progress border
  `,
};

